import { render } from "./VolumeBuyTiersTable.vue?vue&type=template&id=b428e80a&scoped=true"
import script from "./VolumeBuyTiersTable.vue?vue&type=script&lang=js"
export * from "./VolumeBuyTiersTable.vue?vue&type=script&lang=js"

import "./VolumeBuyTiersTable.vue?vue&type=style&index=0&id=b428e80a&lang=scss&scoped=true"
import "./VolumeBuyTiersTable.vue?vue&type=style&index=1&id=b428e80a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b428e80a"]])

export default __exports__